/* eslint-disable */

if (!String.prototype.replaceAll) {
    String.prototype.replaceAll = function(str, newStr) {
        if (Object.prototype.toString.call(str).toLowerCase() === '[object regexp]') {
            return this.replace(str, newStr)
        }
        var reg = String(str).replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
        return this.replace(new RegExp(reg, 'g'), newStr)
    }
}


// WEBPACK FOOTER //
// ./src/twd/polyfills.js